import Interaction from "../models/interactions/Interaction";
import { getKeysFromInteraction } from "./KeysHelper";

export const LOCALIZATION_KEY_PREFIX = "key_";

export function copyInteractionWithLocalizationFallback<T extends Interaction>(
  interaction: T,
  getKeys: (amount: number) => string[],
  replaceKey: (from: string, to: string) => void,
  createId: () => string,
): T {
  const originalKeys = [
    ...new Set(getKeysFromInteraction(interaction, LOCALIZATION_KEY_PREFIX)),
  ];
  const newKeys = originalKeys.length > 0 ? getKeys(originalKeys.length) : [];
  const keyMap = new Map(
    originalKeys.map((key, index) => [key, newKeys[index]]),
  );

  keyMap.forEach((newKey, originalKey) => {
    replaceKey(originalKey, newKey);
  });

  const clonedInteraction = cloneWithReplacedKeys(interaction, keyMap);
  return {
    ...clonedInteraction,
    id: createId(),
  };
}

function cloneWithReplacedKeys<T>(value: T, keyMap: Map<string, string>): T {
  if (value === null || value === undefined) return value;

  if (typeof value === "string") {
    return (keyMap.get(value) ?? value) as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => cloneWithReplacedKeys(item, keyMap)) as T;
  }

  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        cloneWithReplacedKeys(nestedValue, keyMap),
      ]),
    ) as T;
  }

  return value;
}
